import * as z from "zod/v4";

export const LoginFormSchema = z.object({
    email: z.email("errors.invalidEmail"),
    password: z.string().min(6, "errors.loginPasswordMin"),
});